import {
  CascadiaTheme,
  ThemeContext,
} from "@certn/cascadia/context/ThemeContext";
import { PropsWithChildren } from "react";

import { GlobalStyles } from "./GlobalStyles";

interface Props extends PropsWithChildren {
  theme?: CascadiaTheme;
  setTheme: (theme: CascadiaTheme) => void;
}

export function ThemeProvider(props: Props) {
  const { theme = "system", setTheme, children } = props;

  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme,
      }}
    >
      <GlobalStyles>{children}</GlobalStyles>
    </ThemeContext.Provider>
  );
}
